// import Loader from "@Common/Loader";
import { useFrontViewedDepth } from "@hook";

import { inject, observer } from "mobx-react";
import { useEffect } from "react";
// import { Suspense, lazy } from "react";

import Cookies from "../../../components/Cookies";
import Footer from "../../../components/Footer";
import Geolocation from "../../../components/Geolocation/index";
import Header from "../../../components/Header";
import List from "../../../components/Main";
import Modal from "../../Modal";

// const Header = lazy(() => import("../../components/Header"));
// const Footer = lazy(() => import("../../components/Footer"));
// const List = lazy(() => import("../../components/Main/List"));

// const Cookies = lazy(() => import("../../components/Cookies"));
// const Geolocation = lazy(() => import("../../components/Geolocation/Default"));

import "./style.scss";

const Main = inject("mainStore")(
    observer(({ mainStore }) => {
        const isVisible = mainStore.getMainStore("isVisible");
        const isCoverRoot = mainStore.getMainStore("isCoverRoot");
        const { _off_lg_id } = mainStore.getMainStore("offersList");
        const { type } = mainStore.getMainStore("modal");

        useEffect(() => {
            window.scrollTo(0, 1);
        }, []);

        useFrontViewedDepth(type, _off_lg_id);

        return (
            <>
                {isVisible && (
                    <div className="main-container">
                        {/* удалить как в ios26 пофиксят прозрачность полосок браузера */}
                        {isCoverRoot ? <div className="main-container__cover" /> : null}
                        {/* удалить как в ios26 пофиксят прозрачность полосок браузера */}
                        <Header />
                        <Geolocation />
                        <List />
                        <Footer />
                    </div>
                )}
                <Cookies />
                <Modal />
            </>
        );
    }),
);

export default Main;
